import React from 'react';

export default function BoardEdge(props) {
    return <div className="board-edge"></div>;
}
